import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Features from './components/Features';
import Benefits from './components/Benefits';
import DemoVideo from './components/DemoVideo';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Blog from './components/Blog';
import { initSmoothScroll } from './smoothScroll';

// Lazy load heavy components
const TDEECalculator = lazy(() => import('./components/TDEECalculator/TDEECalculator'));
const ProfessionalsPage = lazy(() => import('./components/pages/ProfessionalsPage'));

function App() {
  useEffect(() => {
    initSmoothScroll();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-background text-primary">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <HeroSection />
              <main>
                <Benefits />
                <Features />
                <DemoVideo />
                <Pricing />
                <FAQ />
              </main>
            </>
          } />
          <Route path="/tdee-calculator" element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-primary">Loading...</div></div>}>
              <TDEECalculator />
            </Suspense>
          } />
          <Route path="/blog" element={<Blog />} />
          <Route path="/professionals" element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-primary">Loading...</div></div>}>
              <ProfessionalsPage />
            </Suspense>
          } />
        </Routes>
        <Footer />
        <CookieConsent />
        <Analytics />
        <SpeedInsights />
      </div>
    </Router>
  );
}

export default App;
